var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58173 3.58172 0 8 0H27.9966C32.4149 0 35.9966 3.58172 35.9966 8V27.9966C35.9966 32.4149 32.4149 35.9966 27.9966 35.9966H8C3.58173 35.9966 0 32.4149 0 27.9966V8Z",
    fill: "#0A0A0A",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0027 24.6576V12.671C14.0027 12.3177 14.1431 11.979 14.3928 11.7292C14.6426 11.4794 14.9814 11.3391 15.3346 11.3391H20.662C21.0152 11.3391 21.354 11.4794 21.6038 11.7292C21.8535 11.979 21.9938 12.3177 21.9938 12.671V24.6576H14.0027Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0028 17.9985H12.6709C12.3177 17.9985 11.9789 18.1389 11.7291 18.3886C11.4794 18.6384 11.3391 18.9772 11.3391 19.3304V23.3259C11.3391 23.6792 11.4794 24.0179 11.7291 24.2677C11.9789 24.5175 12.3177 24.6578 12.6709 24.6578H14.0028",
    stroke: "#0A0A0A",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9939 16.0007H23.3257C23.6789 16.0007 24.0177 16.1411 24.2675 16.3908C24.5172 16.6406 24.6576 16.9794 24.6576 17.3326V23.3259C24.6576 23.6791 24.5172 24.0179 24.2675 24.2677C24.0177 24.5174 23.6789 24.6578 23.3257 24.6578H21.9939",
    stroke: "#0A0A0A",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6664 14.0029H19.3301",
    stroke: "#0A0A0A",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6664 16.6665H19.3301",
    stroke: "#0A0A0A",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6664 19.3303H19.3301",
    stroke: "#0A0A0A",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6664 21.9939H19.3301",
    stroke: "#0A0A0A",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9822,
    height: 15.9822,
    fill: "white",
    transform: "translate(10.0072 10.0073)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingIcon);
export default __webpack_public_path__ + "static/media/bookingIcon.c5e7ce62ff20d309288ae1588a5d0e13.svg";
export { ForwardRef as ReactComponent };